import { DELETE_VENDOR_WORK_ORDER, GET_VENDOR_WORK_ORDER_DETAILS, GET_VENDOR_WORK_ORDER_LIST, INSERT_UPDATE_VENDOR_WORK_ORDER } from "../../../../utils/constants";


const initialState = [];

function vendorWorkOrder_reducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case GET_VENDOR_WORK_ORDER_LIST:
            return [...state, payload];
        case INSERT_UPDATE_VENDOR_WORK_ORDER:
            return [...state, payload];
        case GET_VENDOR_WORK_ORDER_DETAILS:
            return [...state, payload];
        case DELETE_VENDOR_WORK_ORDER:
            return [...state, payload];
        default:
            return state;
    }
}
export default vendorWorkOrder_reducer;